import { QuerySuggestionResponse } from '../@types/QuerySuggestion';
import useFetch from './useFetch';

const useQuerySugesstion = (url: string, query: string) => {
  const skip = query.length < 2;
  const {
    loading,
    data: response,
    error,
  } = useFetch<QuerySuggestionResponse>(`${url}${query ? `?q=${query}` : ''}`, {}, skip);

  const value = {
    loading,
    error,
    response: skip ? undefined : response,
  };

  return value;
};

export default useQuerySugesstion;
